<!--
 * @Author: hcw
 * @Date: 2022-08-24 15
-->
<!--
 * @Author: your name
 * @Date: 2022-05-17 09
-->
<template>
  <div class="footer-max">
    <div class="footer-head">
      <!-- <div class="footer-link">
        <div>产品世界</div>
        <div>媒体中心</div>
      </div> -->
      <div class="footer-phone">客服热线：<span>400-007-1768（7×24小时）</span></div>
      <div class="footer-address" @click="topath">地址：<span>重庆市九龙坡区聚业路116号</span></div>
<!--      <div class="footer-work">&nbsp;</div>-->
    </div>
    <div class="footer-center"></div>
    <div class="footer-bottom">
      <div class="footer-name">
        <div class="footer-name-ch">隆鑫通用动力股份有限公司</div>
        <div class="footer-name-en">COPYRIGHT© 2022 LONGXING ALL RIGHTS RESERVED <span class="icp" @click="toIcp">渝ICP备11000576号</span></div>
      </div>
      <div class="footer-advertising">
        <el-popover
          placement="top"
          trigger="hover">
          <img class="ewm-img" src="../assets/footer-wb.png" alt="">
          <div slot="reference" class="footer-advertising-list">
            <div class="img"><img src="../assets/weibo.png" alt=""></div>
            <div class="text">无极摩托官方微博</div>
          </div>
        </el-popover>

        <el-popover
          placement="top"
          trigger="hover">
          <img class="ewm-img" src="../assets/footer-wx.jpg" alt="">
          <div class="footer-advertising-list" slot="reference">
            <div class="img"><img src="../assets/weixin.png" alt=""></div>
            <div class="text">无极摩托官方微信</div>
          </div>
        </el-popover>

        <el-popover
          placement="top"
          trigger="hover">
          <img class="ewm-img" src="../assets/footer-dy.png" alt="">
          <div class="footer-advertising-list" slot="reference">
            <div class="img"><img src="../assets/douyin.png" alt=""></div>
            <div class="text">VOGE抖音账号</div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    topath(){
      window.open('https://map.baidu.com/search/%E9%87%8D%E5%BA%86%E5%B8%82%E4%B9%9D%E9%BE%99%E5%9D%A1%E5%8C%BA%E4%B9%9D%E9%BE%99%E5%9B%AD%E5%8C%BA%E5%8D%8E%E9%BE%99%E5%A4%A7%E9%81%9399%E5%8F%B7/@11850638.125,3414702,19z?querytype=s&da_src=shareurl&wd=%E9%87%8D%E5%BA%86%E5%B8%82%E4%B9%9D%E9%BE%99%E5%9D%A1%E5%8C%BA%E4%B9%9D%E9%BE%99%E5%9B%AD%E5%8C%BA%E5%8D%8E%E9%BE%99%E5%A4%A7%E9%81%9399%E5%8F%B7&c=132&src=0&pn=0&sug=0&l=12&b=(11800578.46,3397260.19;11923458.46,3457228.19)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1','_blanck')
    },
    toIcp(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index','_blanck')
    }
  }
}
</script>
<style lang="scss">
.ewm-img{
  width: 75px;
  height: 75px;
}
.el-popover{
  min-width: 0;
  padding: 0;
}
.footer-max{
  width: 100%;
  height: 189px;
  background: #000000;
  .footer-head{
    max-width: 1422px;
    margin: 0 auto;
    display: flex;
    height: 72px;
    align-items: center;
    justify-content: space-between;
    .footer-link{
      width: 22.8%;
      display: flex;
      justify-content: space-around;
      div{
        font-size: 14px;
        cursor: pointer;
        color: #B7B7B7;
      }
    }
    .footer-phone{
      font-size: 14px;
      font-weight: bold;
      color: #B7B7B7;
      span{
        font-weight: 800;
      }
    }
    .footer-address{
      font-size: 14px;
      color: #B7B7B7;
      font-weight: bold;
      cursor: pointer;
      span{
        font-weight: 800;
      }
    }
    .footer-work{
      font-size: 14px;
      font-weight: bold;
      color: #B7B7B7;
      span{
        font-weight: 800;
      }
    }
  }
  .footer-center{
    max-width: 1452px;
    height: 1px;
    background: #b7b7b7;
    margin: 0 auto;
  }
  .footer-bottom{
    display: flex;
    justify-content: space-between;
    height: 116px;
    max-width: 1422px;
    margin: 0 auto;
    align-items: center;
    .footer-name{
      .footer-name-ch{
        font-size: 14px;
        color: #B7B7B7;
        font-weight: 700;
      }
      .footer-name-en{
        font-size: 14px;
        color: #B7B7B7;
        margin-top: 10px;
      }
      .icp{
        cursor: pointer;
      }
    }
    .footer-advertising{
      display: flex;
      align-content: center;
      width: 535px;
      justify-content: space-between;
      .footer-advertising-list{
        cursor: pointer;
        .img{
          width: 40px;
          height: 40px;
          text-align: center;
          margin: 0 auto;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .text{
          font-size: 14px;
          color: #b7b7b7;
          margin-top: 8px;
        }
      }

    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1400px){
  .footer-head{
    width: 1200px;
    margin: 0 auto;
  }
  .footer-center{
    width: 1200px;
    margin: 0 auto;
  }
  .footer-bottom{
    width: 1200px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseFooter.vue